import { useAxios } from '@/context/axiosContext'
import { useRedis } from '@/hooks/useRedis'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './answerMgmt.css'
import InsertAnswerMgmt from './_component/insertAnswerMgmt'
import { Badge, Table } from '@/components'
import commonUtils from '@/utils/commonUtils'
import numberUtils from '@/utils/numberUtils'

interface DataRow {
  cmpnyCd: string
  templateSn: number
  category: string
  title: string
  content: string
  delYn: string
  useYn: string
  regId: string
  regDate: string
  updId: string
  updDate: string
}
const fieldNames = ['NO.', '제목', '작성자', '작성일', '조회수']

const commonStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center' as const,
}

const AnswerMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const { getComCodeValue, getComCodes } = useRedis()
  const [activeTab, setActiveTab] = useState('about')
  //const [menuList, setMenuList] = useState<MenuInfoData[]>([])
  const [historyReloadFlag, setHistoryReloadFlag] = useState(false)

  const [data, setData] = useState<DataRow[]>([])
  return (
    <>
      {/* <div className="nav-buttons">
        <button className="nav-btn">조회 화면</button>
        <button className="nav-btn">등록 화면</button>
      </div> */}

      <div id="list-screen" className="screen active">
        <div className="template-container">
          {/* <div className="template-header">
            <div className="template-header-content">
              <h1 className="template-title">템플릿 관리</h1>
            </div>
          </div> */}

          <div className="template-main">
            <div className="template-tabs">
              <div className="template-tabs-nav">
                <button className="template-tab active">문의</button>
                <button className="template-tab">소통</button>
                <button className="template-tab">목소리</button>
                <button className="template-tab">공지</button>
              </div>
            </div>

            <div className="template-list-container">
              <div className="template-controls">
                <div className="template-search-container">
                  <div className="template-search-wrapper">
                    <svg
                      className="template-search-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m21 21-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      ></path>
                    </svg>
                    <input
                      type="text"
                      placeholder="템플릿 검색..."
                      className="template-search-input"
                    />
                  </div>
                </div>
                <div className="template-add-btn">
                  <svg
                    className="template-add-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    ></path>
                  </svg>
                  <span>등록</span>
                </div>
              </div>

              <div className="template-table-wrapper">
                <table className="template-table">
                  <thead className="template-table-header">
                    <tr>
                      <th>제목</th>
                      <th>내용</th>
                      <th>카테고리</th>
                      <th>상태</th>
                      <th>등록일</th>
                      <th>관리</th>
                    </tr>
                  </thead>
                  <tbody className="template-table-body">
                    <tr className="template-table-row">
                      <td className="template-table-cell">
                        <div className="template-title-cell">
                          고객 문의 접수 안내
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-content-cell">
                          안녕하세요. 고객님의 문의를 접수받았습니다. 빠른 시일
                          내에 답변드리겠습니다.
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-inquiry">
                          문의
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-active">
                          활성
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-date-cell">2024-01-15</div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-actions">
                          <button className="template-action-btn template-edit-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              ></path>
                            </svg>
                          </button>
                          <button className="template-action-btn template-delete-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr className="template-table-row">
                      <td className="template-table-cell">
                        <div className="template-title-cell">
                          서비스 이용 안내
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-content-cell">
                          서비스 이용에 관한 안내사항입니다. 자세한 내용은
                          고객센터로 문의하세요.
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-inquiry">
                          문의
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-inactive">
                          비활성
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-date-cell">2024-01-14</div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-actions">
                          <button className="template-action-btn template-edit-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              ></path>
                            </svg>
                          </button>
                          <button className="template-action-btn template-delete-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr className="template-table-row">
                      <td className="template-table-cell">
                        <div className="template-title-cell">
                          문의 처리 완료 안내
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-content-cell">
                          고객님의 문의가 정상적으로 처리되었습니다. 감사합니다.
                        </div>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-inquiry">
                          문의
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <span className="template-badge template-badge-active">
                          활성
                        </span>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-date-cell">2024-01-13</div>
                      </td>
                      <td className="template-table-cell">
                        <div className="template-actions">
                          <button className="template-action-btn template-edit-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              ></path>
                            </svg>
                          </button>
                          <button className="template-action-btn template-delete-btn">
                            <svg
                              className="template-action-icon"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default AnswerMgmt
